import React from "react";
import { Tooltip } from "antd";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const CompanyLink = ({ id, text, action }) => {
  const { navigateToCompanyDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (action) {
      navigateToCompanyDetail(id);
    }
  };

  return (
    <Tooltip title={text}>
      <a
        onClick={handleClick}
        style={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          cursor: 'pointer'
        }}
      >
        {text}
      </a>
    </Tooltip>
  );
};

export default CompanyLink;

